
import { useParams } from "react-router-dom"
import Footer from "../../components/footer/Footer"
import Navbar from "../../components/navbar/Navbar"
import styled from "./articlePage.module.css"
import { useEffect, useState } from "react"
import axios from "axios"
function ArticlePage(){

   const params= useParams();//hook
    const [article, setArticle]= useState({}) ;
     const [isLoading,setIsLoading]=useState(false) ;

  useEffect(() => {
  setIsLoading(true);

  axios.get("/db.json")
    .then((res) => {
      console.log("params:", params.id);

      // پیدا کردن مقاله بر اساس id
      const article = res.data.articles.find(
        (item) => String(item.id) === String(params.id)
      );

      setArticle(article);
      setIsLoading(false);
    })
    .catch((err) => {
      console.log(err);
      setIsLoading(false);
    });

}, [params.id]);


    return(

        <>
             <Navbar title="سایت عوض نیا" />
        <div className={styled.articleWraper} >
        <div className="container">
              {  isLoading? (<p>چند لحظه صبر کنین</p>):(
        <>
        <h1>{article.title}</h1>
        <div className={styled.articleInfo}>
            <span>
                تاریخ: {article.date}
            </span>
            <span>
             نویسنده:{article.autor}
            </span>
            <span>
               مدت زمان {article.readingTime}
            </span>
        </div>
       
        <img src={article.imgUrl} alt="aks"></img>
       
        <p>  {article.content}</p>
        </>
              )}
        
        </div>
        </div>
        <Footer></Footer>
        </>

    )
};
export default ArticlePage
